import moment from 'moment';

// session.plans の人員別料金が null のとき、localStorage の planDetail.plans で補完する
export const mergeSessionPlansWithPlanDetail = (sessionPlans, planDetailPlans) => {
  if (!(sessionPlans && sessionPlans.length) || !(planDetailPlans && planDetailPlans.length)) {
    return sessionPlans;
  }

  return sessionPlans.map((plan, index) => {
    const detailPlan = planDetailPlans[index] && planDetailPlans[index].plan;
    if (!detailPlan) {
      return plan;
    }
    return {
      ...plan,
      adultPrice: plan.adultPrice != null ? plan.adultPrice : detailPlan.adultPrice,
      childrenAPrice: plan.childrenAPrice != null ? plan.childrenAPrice : detailPlan.childrenAPrice,
      childrenBPrice: plan.childrenBPrice != null ? plan.childrenBPrice : detailPlan.childrenBPrice,
      childrenCPrice: plan.childrenCPrice != null ? plan.childrenCPrice : detailPlan.childrenCPrice,
      children2Price: plan.children2Price != null ? plan.children2Price : detailPlan.children2Price,
      infantPrice: plan.infantPrice != null ? plan.infantPrice : detailPlan.infantPrice,
    };
  });
};

export const getSessionPlansTotalAmount = (sessionPlans) => {
  let plansTotalAmount = 0;
  sessionPlans && sessionPlans.forEach((sessionPlan) => {
    plansTotalAmount += sessionPlan.totalAmount;
  });

  return plansTotalAmount;
};

export const getPlanFromPlansByDate = (plans, date) => {
  if (!(plans && plans.length)) return undefined;

  // 破壊しないよう最初にcloneしてから日単位へ
  const d = date.clone().startOf('day');

  let firstDay = false;

  const plan = plans.find((p) => {
    const { startDate, stayNights } = p;
    const start = moment(startDate).startOf('day'); // 同じく日単位へ
    const diff = d.diff(start, 'days');             // 整数でOK

    if (diff === 0) firstDay = true;
    return diff >= 0 && diff < stayNights;          // 0 以上 stayNights 未満
  });

  return plan && {
    ...plan.plan,
    checkin: plan.checkin,
    firstDay,
  };
};

export const getPlanFromSessionPlansByDate = (sessionPlans, date) => {
  if (!(sessionPlans && sessionPlans.length)) {
    return undefined;
  }

  let firstDay = false;

  const plan = sessionPlans.find((sessionPlan) => {
    const { date: sessionPlanDate, stayNights } = sessionPlan;
    const planStartDate = moment(sessionPlanDate);
    const diff = date.diff(planStartDate, 'days');
    if (diff === 0) {
      firstDay = true;
    }

    return -1 < diff && diff < stayNights;
  });

  return plan && {
    ...plan,
    checkin: plan.checkin,
    firstDay,
  };
};

export const getStayNightsFromPlan = (plan, plans) => {
  if (!(plans && plans.length)) {
    return 0;
  }

  const item = plans.find((p) => {
    return p.plan.id === plan.id;
  });

  return item && item.stayNights;
};

export const getDaysToNextPlan = (date, plans) => {
  if (!(plans && plans.length)) {
    return undefined;
  }

  const plansDates = plans.map((p) => moment((p.startDate)));
  const plansDatesDiff = plansDates.map((startDate) => startDate.diff(date, 'days')).filter((d) => d > 0);

  const minDiff = plansDatesDiff.reduce((pre, current) => {
    return current < pre ? current : pre;
  }, plansDatesDiff[0]);

  return minDiff;
};
